import { useCallback, useEffect, useState } from 'react';
import { FaFacebookSquare, FaLinkedin, FaPhoneAlt, FaRegIdBadge, FaTrash, FaUser, FaUserCircle, FaUserEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Header, ScrollProps } from '../../components/Header';
import { IBuildindCorretor, IcarrosselImoveis, IPropsCorretor } from '../../types';
import { BsInstagram, BsPatchCheckFill } from 'react-icons/bs';
import { TfiIdBadge } from 'react-icons/tfi';
import { BiCreditCardFront } from 'react-icons/bi';
import { PiLinkSimpleBold } from "react-icons/pi";

import {
    Container,
    Wrapper,
    ContentModalAvatar,
    ContainerIframe,
    Title,
    StyledIframe,
    SaveButton,
    Label,
    InputGroup,
    ButtonAdd,
    WrapperCarrossel,
    TextArea,
    InfoContainer,
    Description
} from './styles';

import { CardInfo } from '../../components/CardInfo';
import ModalProposta from '../../components/Proposta/ModalProposta';
import { Footer } from '../../components/Footer';
import { useAuth } from '../../context/auth';
import { LoadSpinner2 } from '../../components/LoadSpinner2';
import { IoEye, IoMailOutline } from 'react-icons/io5';
import Carousel from 'react-multi-carousel';
import { HiCheck, HiPencil } from 'react-icons/hi';
import { IoIosAddCircle, IoMdClose, IoMdEyeOff } from 'react-icons/io';
import { GoToTop } from '../../GoToTop';
import { Input, Modal } from 'antd';
import { LoadSpinnerLogin } from '../../components/LoadSpinnerLogin';
import { maskPhone } from '../../utils/mask';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Lottie from 'react-lottie';
import animationData from '../../lotties/loading-white.json';
import { RiMoneyDollarCircleFill } from 'react-icons/ri';
import { MdModeEdit } from 'react-icons/md';
import { CardImovelList } from '../../components/CardImovelList';

const MySwal = withReactContent(Swal)

export function InternalProfile() {

    const { user, setAvatarModification, avatarModification, api } = useAuth()

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fotoPerfil = new FormData();

    const [corretor, setCorretor] = useState<IPropsCorretor>({} as IPropsCorretor)
    const [loading, setLoading] = useState(false)
    const [loading3, setLoading3] = useState(false)

    const loadData = useCallback(async () => {
        setLoading3(true)
        await api.get(`/portal/corretor/${user.id_corretor}`).then(res => {
            setCorretor(res.data)
        }).catch(e => console.log(e)).finally(() => setLoading3(false))
    }, [user.id_corretor, api])

    const navigate = useNavigate();
    const [building, setBuilding] = useState<IBuildindCorretor[]>([]);
    const [buildingDestaque, setBuildingDestaque] = useState<IBuildindCorretor[]>([])
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // const [page, setPage] = useState(0);
    const [lat, setLat] = useState<number>(0);
    const [long, setLong] = useState<number>(0);

    const loadBuildings = useCallback(() => {
        setLoading(true)
        api.get(`/portal/building/list-building/0?query_search&is_sale&min_sale_price&max_sale_price&is_rent&min_rent_price&max_rent_price&seller=${user.id_corretor}&constructor&no_address=1&id_category&is_highlight&id_corretor=${user.id_corretor}`)
            .then((res) => {
                setBuilding(res.data);
                // console.log(res.data)
            })
            .catch(e => console.log(e.response.data.message))
            .finally(() => setLoading(false));
    }, [user.id_corretor, api]);

    const loadBuildingsDestaque = useCallback(() => {
        // setLoading2(true)
        api.get(`/portal/building/list-building/0?query_search&is_sale&min_sale_price&max_sale_price&is_rent&min_rent_price&max_rent_price&seller&constructor&no_address=1&id_category&is_highlight=1&id_corretor=${user.id_corretor}`).then(res => {
            setBuildingDestaque(res.data)
        }).catch(e => console.log(e)).finally(
            // () => setLoading2(false)
        )
    }, [user, api])

    useEffect(() => {
        loadBuildings();
        loadBuildingsDestaque();
        loadData();
    }, [loadBuildings, loadBuildingsDestaque, loadData]);

    useEffect(() => {
        navigator.geolocation.watchPosition(position => {
            const { latitude, longitude } = position.coords;
            setLat(latitude ? latitude : 0);
            setLong(longitude ? longitude : 0);
        });
    }, [])

    function preparaString(input: string) {
        input = input.toLowerCase().replaceAll(' ', '-').replaceAll('ç', 'c');
        input = input.replace(/[^a-zA-Z-]/g, '').replaceAll('--', '-')
        return input
    }

    const [scrollTop, setScrollTop] = useState<ScrollProps>({ y: 0, lastY: 0 } as ScrollProps);
    const [show, setShow] = useState(false);

    const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
        const scrollTop = event.currentTarget.scrollTop;
        setScrollTop(prevState => { return { y: scrollTop, lastY: prevState.y } })
    }

    const [viewInputNameCorrector, setViewInputNameCorrector] = useState(false);
    const [viewInputEmail, setViewInputEmail] = useState(false);
    const [viewInputContato1, setViewInputContato1] = useState(false);
    const [viewInputInsta, setViewInputInsta] = useState(false);
    const [viewInputFace, setViewInputFace] = useState(false);
    const [editSlug, setEditSlug] = useState(false);
    const [viewInputLinke, setViewInputLinke] = useState(false);
    const [modalAvatar, setModalAvatar] = useState(false);
    const [search, setSearch] = useState('');

    const [contato1, setContato1] = useState('');
    const [inputSlug, setInputSlug] = useState('');
    const [nameVirtualCard, setNameVirtualCard] = useState('');
    const [emailContato, setEmailContato] = useState('');
    const [insta, setInsta] = useState('');
    const [face, setFace] = useState('');
    const [linke, setLinke] = useState('');
    const [avatar, setAvatar] = useState<any>();
    const [successRequisition, setSuccessRequisition] = useState<any>();

    const [editingCarrossel, setEditingCarrossel] = useState(false);
    const [idEditingCarrossel, setIdEditingCarrossel] = useState(-1);
    const [nomeEditingCarrossel, setNomeEditingCarrossel] = useState('');
    const [descricaoEditingCarrossel, setDescricaoEditingCarrossel] = useState('');
    const [publicadoEditingCarrossel, setPublicadoEditingCarrossel] = useState(true);

    const [imoveisEditing, setImoveisEditing] = useState<IBuildindCorretor[]>([]);
    const [idImoveisEditing, setIdImoveisEditing] = useState<number[]>([]);

    const [imoveisCarrosseis, setImoveisCarrosseis] = useState<IcarrosselImoveis[]>([]);

    const [openFinance, setOpenFinance] = useState(false);
    const [novaPropostaOpen, setNovaPropostaOpen] = useState(false);
    // const [pdfVirtual, setPdfVirtual] = useState('');

    const handleOpenFinance = () => {
        setOpenFinance(true);
    }

    const handleCloseFinance = () => {
        setOpenFinance(false);
    }

    const handleCLoseEditCarrossel = () => {
        setEditingCarrossel(false);
        setIdEditingCarrossel(-1);
        setNomeEditingCarrossel('');
        setDescricaoEditingCarrossel('');
        setImoveisEditing([]);
    }

    useEffect(() => {
        setContato1(corretor?.telefone_01);
        setEmailContato(corretor?.email_contato);
        setInsta(corretor?.instagram);
        setFace(corretor?.facebook);
        setLinke(corretor?.linkedin);
    }, [corretor])

    const handleEditInfos = useCallback(async () => {
        MySwal.fire({
            title: 'Aguarde',
            text: 'Estamos salvando as informações',
            icon: 'warning',
            didOpen: () => {
                MySwal.showLoading()
            }
        })
        await api.put(`/portal/corretor/${user.id_corretor}`, {
            nome: '',
            creci: '',
            telefone_01: contato1,
            telefone_02: '',
            email_social: '',
            email_contato: emailContato,
            enable_app: '',
            instagram: insta,
            facebook: face,
            linkedin: linke,
            slug: inputSlug
        }).then(res => {
            setContato1('');
            setEmailContato('');
            setInsta('');
            setFace('');
            setLinke('');
            setSuccessRequisition(res.data)
            MySwal.fire({
                icon: 'success',
                title: 'Sucesso!',
                text: 'A edição foi realizada',
                confirmButtonColor: '#0E2244'
            })
        }).catch(e => {
            console.log(e)
            MySwal.fire({
                icon: 'error',
                title: 'Ops!',
                text: `${e.response.data.err}`,
                confirmButtonColor: '#0E2244',
                // footer: `${e.response.data.err}`
            })
        }).finally()
    }, [api, user.id_corretor, contato1, emailContato, insta, face, linke, inputSlug])

    const handleEditAvatar = useCallback(async () => {
        fotoPerfil.append('arquivo', avatar[0]);
        MySwal.fire({
            title: 'Aguarde',
            text: 'Estamos salvando as informações',
            icon: 'warning',
            didOpen: () => {
                MySwal.showLoading()
            }
        })
        await api.post(`/portal/corretor/foto-perfil/${user.id_corretor}`, fotoPerfil).then(res => {
            setModalAvatar(false);
            setAvatarModification(res.data)
            MySwal.fire({
                icon: 'success',
                title: 'Sucesso!',
                text: 'A edição foi realizada',
                confirmButtonColor: '#0E2244'
            })
        }).catch(e => {
            console.log(e);
            MySwal.fire({
                icon: 'error',
                title: 'Ops!',
                text: 'Não foi possível editar esta informação',
                confirmButtonColor: '#0E2244',
                footer: `${e.response.data.err}`
            })
        })
    }, [user, avatar, fotoPerfil, setAvatarModification, api])

    useEffect(() => {
        loadData()
    }, [loadData, avatarModification, successRequisition])

    const [loadingPdfCreator, setLoadingPdfCreator] = useState(false);

    const cartaoVirtual = useCallback(async () => {
        try {
            const response = await api.get(`/utils/get-contact-pdf/${user.id_corretor}`, {
                responseType: 'arraybuffer',
            })

            return new Blob([response.data], { type: 'application/pdf' });
        } catch (error) {
            console.error('Erro ao buscar o documento PDF:', error);
            return null;
        }
    }, [api, user.id_corretor])

    const openPDFcartao = async () => {
        setLoadingPdfCreator(true)
        const pdfBlob = await cartaoVirtual()

        if (pdfBlob) {
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank')
        }
        setLoadingPdfCreator(false)
    };

    const defaultOptions = {
        loop: true,
        animationData: animationData,
    }

    const handleEditNameVirtualCard = useCallback(async () => {
        MySwal.fire({
            title: 'Aguarde',
            text: 'Estamos salvando as informações',
            icon: 'warning',
            didOpen: () => {
                MySwal.showLoading()
            }
        })
        await api.post(`/sin/corretor/nome-cartao/${user.id_corretor}`, {
            nome: nameVirtualCard
        }).then(res => {
            setNameVirtualCard('')
            setViewInputNameCorrector(false)
            loadData()
            MySwal.fire({
                icon: 'success',
                title: 'Sucesso!',
                text: 'A edição foi realizada',
                confirmButtonColor: '#0E2244'
            })
        }).catch(e => {
            console.log(e)
            MySwal.fire({
                icon: 'error',
                title: 'Ops!',
                text: 'Não foi possível editar esta informação',
                confirmButtonColor: '#0E2244',
                footer: `${e.response.data.err}`
            })
        }).finally()
    }, [nameVirtualCard, api, user, loadData])

    const handleEditSlug = () => {
        MySwal.fire({
            title: 'Atenção!',
            text: 'Você está preste a alterar a URL do seu link de vendas. Seus links personalizados enviados anteriormente deixarão de funcionar. Tem certeza que deseja alterar?',
            icon: 'warning',
            confirmButtonText: 'SIM, ESTOU CIENTE',
        }).then((result) => {
            if (result.isConfirmed) {
                setEditSlug(true);
            }
        })
    }

    const getCarrosseis = useCallback(async () => {
        await api.get(`/portal/carrossel/list-carrossel?portal=hub&id_corretor=${user.id_corretor}`).then(response => {
            setImoveisCarrosseis(response.data.data)
        }).catch(e => console.log('não foi possivel carregar os carrosseis', e))
    }, [api, user.id_corretor])

    const handleDeleteCarrossel = (id: number) => {
        MySwal.fire({
            title: 'Atenção!',
            text: 'Tem certeza que deseja excluir o carrossel?',
            icon: 'warning',
            confirmButtonText: 'Excluir',
            showCancelButton: true,

        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/portal/carrossel/delete/${id}?portal=hub`).then(res => {
                    MySwal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text: 'O carrossel foi excluido com sucesso',
                        confirmButtonColor: '#0E2244'
                    })
                    getCarrosseis()
                }).catch(e => {
                    console.log(e)
                    MySwal.fire({
                        icon: 'error',
                        title: 'Ops!',
                        text: 'Não foi possível excluir o carrossel',
                        confirmButtonColor: '#0E2244',
                    })
                })
            }
        })
    }

    const openModalEditCarrossel = (id: number, nome: string, descricao: string, publicado: boolean, imoveis: IBuildindCorretor[]) => {
        setEditingCarrossel(true);
        setIdEditingCarrossel(id);
        setNomeEditingCarrossel(nome);
        setDescricaoEditingCarrossel(descricao);
        setImoveisEditing(imoveis);
        setPublicadoEditingCarrossel(publicado);
        setIdImoveisEditing(imoveis.map(imovel => imovel.id));

    }

    const handleEditCarrossel = async () => {
        if (idEditingCarrossel === -1) { //criando novo
            await api.post(`/portal/carrossel/upsert?portal=hub`, {
                nome: nomeEditingCarrossel,
                descricao: descricaoEditingCarrossel,
                imoveis: idImoveisEditing,
                publicado: publicadoEditingCarrossel ? 1 : 0
            }).then(res => {
                MySwal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    text: 'O carrossel foi criado com sucesso',
                    confirmButtonColor: '#0E2244'
                })
                handleCLoseEditCarrossel();
                getCarrosseis();
            }).catch(e => {
                console.log(e)
                MySwal.fire({
                    icon: 'error',
                    title: 'Ops!',
                    text: `${'Não foi possível criar o carrossel'}`,
                    confirmButtonColor: '#0E2244',

                })
                handleCLoseEditCarrossel();
            })
        } else {
            await api.post(`/portal/carrossel/upsert/${idEditingCarrossel}?portal=hub`, {
                nome: nomeEditingCarrossel,
                descricao: descricaoEditingCarrossel,
                imoveis: idImoveisEditing,
                publicado: publicadoEditingCarrossel ? 1 : 0
            }).then(res => {
                MySwal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    text: 'O carrossel foi editado com sucesso',
                    confirmButtonColor: '#0E2244'
                })
                handleCLoseEditCarrossel();
                getCarrosseis();
            }).catch(e => {
                console.log(e)
                MySwal.fire({
                    icon: 'error',
                    title: 'Ops!',
                    text: `${'Não foi possível editar o carrossel'}`,
                    confirmButtonColor: '#0E2244',
                })
                handleCLoseEditCarrossel();
            })
        }
    }

    const addIMoveltoCarrossel = (imovel: IBuildindCorretor) => {
        setImoveisEditing([imovel, ...imoveisEditing]);
    }

    const removeIMovelfromCarrossel = (id_imovel: number) => {
        setImoveisEditing(imoveisEditing.filter(imovel => imovel.id !== id_imovel));
        setIdImoveisEditing(idImoveisEditing.filter(id => id !== id_imovel));
    }

    useEffect(() => {
        getCarrosseis();
    }, [getCarrosseis])

    return (
        <Container onScroll={handleScroll}>
            <ModalProposta
                open={novaPropostaOpen}
                onClose={() => setNovaPropostaOpen(false)}
                mode="create"
            />
            <Header show={show} setShow={setShow} scroll={scrollTop} search={search} setSearch={setSearch} />
            {
                (loading3) &&
                <LoadSpinner2 />
            }
            {
                (!loading3) &&
                <>
                    <Wrapper>
                        <div className="box-left">
                            <div className="photo">
                                {
                                    corretor?.foto_perfil ?
                                        <>
                                            <img onClick={() => setModalAvatar(true)} src={corretor?.foto_perfil} className='avatar' alt='Avatar do usuário' />
                                            <p onClick={() => setModalAvatar(true)} className='edition'>Editar <HiPencil /></p>
                                        </>
                                        :
                                        <>
                                            <FaUserCircle onClick={() => setModalAvatar(true)} className='avatar' />
                                            <p onClick={() => setModalAvatar(true)} className='edition'>Editar <HiPencil /></p>
                                        </>
                                }
                                <h1>{corretor?.nome}</h1>
                                <p>Especialista Nogueira <BsPatchCheckFill className='check' /> </p>
                            </div>
                            <div className="validate-profile">
                                <ul>
                                    <li>
                                        <TfiIdBadge className='icons-corretor' />
                                        <p className='infos-person'>
                                            CRECI: {corretor?.creci}
                                        </p>
                                    </li>
                                    <li>
                                        <FaUserEdit className='icons-corretor' />
                                        {viewInputNameCorrector ?
                                            <><input type="text" placeholder='Nome no cartão virtual' value={nameVirtualCard} onChange={(e) => setNameVirtualCard(e.target.value)} /><button className='button-cancel' onClick={() => setViewInputNameCorrector(false)}><IoMdClose /></button><button className='button-accept' onClick={() => { setViewInputNameCorrector(false); handleEditNameVirtualCard() }}><HiCheck /></button></>
                                            :
                                            <p className='infos-person'>{corretor?.nome_cartao_virtual ? `Nome cartão virtual: ${corretor?.nome_cartao_virtual}` : 'Não informado'}</p>
                                        }
                                        <HiPencil className='editions-infos' onClick={() => setViewInputNameCorrector(true)} />
                                    </li>
                                    <li>
                                        <IoMailOutline className='icons-corretor' />
                                        {viewInputEmail ?
                                            <><input type="text" placeholder='seuemail@email.com' value={emailContato} onChange={(e) => setEmailContato(e.target.value)} /><button className='button-cancel' onClick={() => setViewInputEmail(false)}><IoMdClose /></button><button className='button-accept' onClick={() => { setViewInputEmail(false); handleEditInfos() }}><HiCheck /></button></>
                                            :
                                            <p className='infos-person'>{corretor?.email_contato ? corretor?.email_contato : 'Não informado'}</p>
                                        }
                                        <HiPencil className='editions-infos' onClick={() => setViewInputEmail(true)} />
                                    </li>
                                    <li>
                                        <FaPhoneAlt className='icons-corretor' />
                                        {viewInputContato1 ?
                                            <><input type="text" maxLength={11} value={maskPhone(contato1 ? contato1 : '')} onChange={(e) => setContato1(e.target.value)} /><button className='button-cancel' onClick={() => setViewInputContato1(false)}><IoMdClose /></button><button className='button-accept' onClick={() => { setViewInputContato1(false); handleEditInfos() }}><HiCheck /></button></>
                                            :
                                            <p className='infos-person'>{corretor?.telefone_01 ? maskPhone(corretor?.telefone_01 ? corretor?.telefone_01 : '') : 'Não informado'}</p>
                                        }
                                        <HiPencil className='editions-infos' onClick={() => setViewInputContato1(true)} />
                                    </li>
                                    <li>
                                        <BsInstagram className='icons-corretor' />
                                        {viewInputInsta ?
                                            <><input value={insta} onChange={(e) => setInsta(e.target.value)} type="text" /><button className='button-cancel' onClick={() => setViewInputInsta(false)}><IoMdClose /></button><button className='button-accept' onClick={() => { setViewInputInsta(false); handleEditInfos() }}><HiCheck /></button></>
                                            :
                                            <p className='infos-person'>{corretor?.instagram ? corretor?.instagram : 'Não informado'}</p>
                                        }
                                        <HiPencil className='editions-infos' onClick={() => setViewInputInsta(true)} />
                                    </li>
                                    <li>
                                        <FaFacebookSquare className='icons-corretor' />
                                        {viewInputFace ?
                                            <><input type="text" value={face} onChange={(e) => setFace(e.target.value)} /><button className='button-cancel' onClick={() => setViewInputFace(false)}><IoMdClose /></button><button className='button-accept' onClick={() => { setViewInputFace(false); handleEditInfos() }}><HiCheck /></button></>
                                            :
                                            <p className='infos-person'>{corretor?.facebook ? corretor?.facebook : 'Não informado'}</p>
                                        }
                                        <HiPencil className='editions-infos' onClick={() => setViewInputFace(true)} />
                                    </li>
                                    <li>
                                        <FaLinkedin className='icons-corretor' />
                                        {viewInputLinke ?
                                            <><input type="text" value={linke} onChange={(e) => setLinke(e.target.value)} /><button className='button-cancel' onClick={() => setViewInputLinke(false)}><IoMdClose /></button><button className='button-accept' onClick={() => { setViewInputLinke(false); handleEditInfos() }}><HiCheck /></button></>
                                            :
                                            <p className='infos-person'>{corretor?.linkedin ? corretor?.linkedin : 'Não informado'}</p>
                                        }
                                        <HiPencil className='editions-infos' onClick={() => setViewInputLinke(true)} />
                                    </li>
                                    <li title='Link do seu portal'>
                                        <PiLinkSimpleBold className='icons-corretor' />
                                        {editSlug ?
                                            <>
                                                <input type="text" placeholder='URL do seu portal' value={inputSlug} onChange={(e) => setInputSlug(preparaString(e.target.value))} />
                                                <button className='button-cancel' onClick={() => setEditSlug(false)}><IoMdClose /></button>
                                                <button className='button-accept' onClick={() => { setEditSlug(false); handleEditInfos() }}><HiCheck /></button></>
                                            :
                                            <p className='infos-person'>{corretor?.slug ? corretor?.slug : 'Não informado'}</p>
                                        }
                                        <HiPencil className='editions-infos' onClick={() => handleEditSlug()} />
                                    </li>
                                </ul>
                                <div className='content-buttons-corretor'>
                                    <button onClick={() => navigate(`/perfil/${corretor?.slug || corretor?.id_sin}`)}>
                                        Acessar perfil
                                        <FaUser className='icon-badge1' />
                                    </button>
                                    <button onClick={openPDFcartao}>
                                        {
                                            loadingPdfCreator ?
                                                <>
                                                    Carregando
                                                    <Lottie options={defaultOptions} height={25} width={25} style={{ margin: '0', padding: '0' }} />
                                                </>
                                                :
                                                <>
                                                    Gerar cartão virtual
                                                    <FaRegIdBadge className='icon-badge2' />
                                                </>
                                        }
                                    </button>
                                    {/* <button className='button-comissao' style={{backgroundColor: '#2962C4'}} onClick={() => navigate(`/detalhes-comissao`)}>
                                        Comissões
                                        <FaMoneyCheckDollar size={20} />
                                    </button> */}
                                    <button className='button-kanban' onClick={() => navigate('/kanban')}>
                                        Propostas Digitais
                                        <BiCreditCardFront className='icon-badge3' />
                                    </button>
                                    <button
                                        className='button-kanban'
                                        type="button"
                                        onClick={() => setNovaPropostaOpen(true)}
                                        style={{ backgroundColor: '#0E2244' }}
                                    >
                                        Nova Proposta
                                        <IoIosAddCircle className='icon-badge3' size={22} />
                                    </button>
                                    <button onClick={handleOpenFinance}>
                                        Simular Financiamento
                                        <RiMoneyDollarCircleFill size={25} className='icon-badge3' />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="box-right">
                            <div className="info-member">
                                <div className="info-member-name">
                                    <h1>{corretor?.nome}</h1>
                                </div>
                            </div>

                            <div className="announcement">
                                <h3>Seus destaques</h3>
                                <div className="cards">
                                    <Carousel
                                        additionalTransfrom={0}
                                        arrows
                                        autoPlay={true}
                                        autoPlaySpeed={3000}
                                        centerMode={false}
                                        className="content-carrosel"
                                        containerClass="container-with-dots"
                                        dotListClass=""
                                        draggable
                                        focusOnSelect={false}
                                        infinite
                                        itemClass="item"
                                        keyBoardControl
                                        minimumTouchDrag={80}
                                        pauseOnHover
                                        renderArrowsWhenDisabled={true}
                                        renderButtonGroupOutside={true}
                                        renderDotsOutside={false}
                                        responsive={{
                                            desktop: {
                                                breakpoint: {
                                                    max: 3000,
                                                    min: 1024
                                                },
                                                items: 2,
                                                partialVisibilityGutter: 40,

                                            },
                                            mobile: {
                                                breakpoint: {
                                                    max: 464,
                                                    min: 0
                                                },
                                                items: 1,
                                                partialVisibilityGutter: 30
                                            },
                                            tablet: {
                                                breakpoint: {
                                                    max: 1024,
                                                    min: 464
                                                },
                                                items: 2,
                                                partialVisibilityGutter: 30
                                            }
                                        }}
                                        rewind={false}
                                        rewindWithAnimation={false}
                                        rtl={false}
                                        shouldResetAutoplay
                                        showDots={false}
                                        sliderClass="slide"
                                        slidesToSlide={1}
                                        swipeable
                                        partialVisbile={false}
                                        partialVisible={false}
                                    >
                                        {buildingDestaque && buildingDestaque.map((item, indx) => {
                                            return (
                                                <CardInfo

                                                    key={indx}
                                                    id={item.id}
                                                    id_display={item.id_display}
                                                    descricao={item.descricao}
                                                    latitude={item.latitude}
                                                    longitude={item.longitude}
                                                    valor_aluguel={item.valor_aluguel}
                                                    valor_venda={item.valor_venda}
                                                    is_venda={item.is_venda}
                                                    is_aluguel={item.is_aluguel}
                                                    periodo_aluguel={item.periodo_aluguel}
                                                    arquivos={item.arquivos}
                                                    lat={lat}
                                                    long={long}
                                                    onClick={() => navigate(`/perfil/${user.id_corretor}/imovel/${item.id}`)}
                                                    idBuilding={item.id}
                                                    is_fixado={item.is_fixado}
                                                    is_destaque={item.is_destaque_corretor}
                                                    is_lancamento={item.is_lancamento}
                                                    is_condominio={item.is_condominio}
                                                    bairro={item.bairro}
                                                    cidade={item.cidade}
                                                    ap_bloco={item.ap_bloco}
                                                    ap_numero={item.ap_numero}
                                                    marginRight='10px'
                                                />
                                            )
                                        })
                                        }
                                    </Carousel>
                                    {buildingDestaque.length < 1 && (
                                        <p>Você ainda não adicionou imóveis para destaque</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Wrapper>

                    <WrapperCarrossel>

                        <div className='conten-cards-imoveis'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap' }}>
                                <h3 style={{ marginBottom: '12px', marginTop: '32px' }}>Suas pastas de imóveis</h3>
                                <ButtonAdd onClick={() => openModalEditCarrossel(-1, '', '', true, [])}>Adicionar novo carrossel <IoIosAddCircle /></ButtonAdd>
                            </div>
                            {imoveisCarrosseis && imoveisCarrosseis.length > 0 && (
                                imoveisCarrosseis.map((item) => {
                                    return (
                                        <div className='carrossel-imoveis'>
                                            <div className='title-carrossel'>
                                                <InfoContainer>
                                                    <Title>{item.nome} {item.publicado === 1 ? <span title='Publicado'><IoEye color='green' /></span> : <span title='Privado'><IoMdEyeOff color='red'/></span>}</Title>
                                                    <Description>{item.descricao}</Description>
                                                </InfoContainer>

                                                <div className='button-options'>
                                                    <div className='button-edit' onClick={() => openModalEditCarrossel(item.id, item.nome, item.descricao, item.publicado === 0 ? false : true, item.imoveis)}><MdModeEdit /></div>
                                                    <div className='button-delete' onClick={() => handleDeleteCarrossel(item.id)}><FaTrash color='#c00' /></div>
                                                </div>
                                            </div>
                                            <div style={{ width: '100%' }}>
                                                <Carousel
                                                    key={`${item.id}-${item.imoveis?.length || 0}`}
                                                    additionalTransfrom={0}
                                                    arrows
                                                    autoPlay={true}
                                                    autoPlaySpeed={3000}
                                                    centerMode={false}
                                                    className="conten-cards-imoveis"
                                                    containerClass="container-with-dots"
                                                    dotListClass=""
                                                    draggable
                                                    focusOnSelect={false}
                                                    infinite
                                                    itemClass=""
                                                    keyBoardControl
                                                    minimumTouchDrag={80}
                                                    pauseOnHover
                                                    renderArrowsWhenDisabled={false}
                                                    renderButtonGroupOutside={false}
                                                    renderDotsOutside={false}
                                                    responsive={{
                                                        desktop: {
                                                            breakpoint: {
                                                                max: 3000,
                                                                min: 1024
                                                            },
                                                            items: 3,
                                                            partialVisibilityGutter: 40,

                                                        },
                                                        mobile: {
                                                            breakpoint: {
                                                                max: 464,
                                                                min: 0
                                                            },
                                                            items: 1,
                                                            partialVisibilityGutter: 30
                                                        },
                                                        tablet: {
                                                            breakpoint: {
                                                                max: 1024,
                                                                min: 464
                                                            },
                                                            items: 2,
                                                            partialVisibilityGutter: 30
                                                        }
                                                    }}
                                                    rewind={false}
                                                    rewindWithAnimation={false}
                                                    rtl={false}
                                                    shouldResetAutoplay
                                                    showDots={false}
                                                    sliderClass="slide"
                                                    slidesToSlide={1}
                                                    swipeable
                                                >
                                                    {
                                                        (item.imoveis) && item.imoveis.map(dataRelacionado => (
                                                            <CardInfo
                                                                key={dataRelacionado.id}
                                                                id={dataRelacionado.id}
                                                                id_display={dataRelacionado.id_display}
                                                                descricao={dataRelacionado.descricao}
                                                                latitude={dataRelacionado.latitude}
                                                                longitude={dataRelacionado.longitude}
                                                                valor_aluguel={dataRelacionado.valor_aluguel}
                                                                valor_venda={dataRelacionado.valor_venda}
                                                                is_venda={dataRelacionado.is_venda}
                                                                is_aluguel={dataRelacionado.is_aluguel}
                                                                periodo_aluguel={dataRelacionado.periodo_aluguel}
                                                                arquivos={dataRelacionado.arquivos}
                                                                lat={lat}
                                                                long={long}
                                                                onClick={() => navigate(`/perfil/${user.id_corretor}/imovel/${dataRelacionado.id}`)}
                                                                idBuilding={dataRelacionado.id}
                                                                is_fixado={dataRelacionado.is_fixado}
                                                                is_destaque={dataRelacionado.is_destaque_corretor}
                                                                is_lancamento={dataRelacionado.is_lancamento}
                                                                is_condominio={dataRelacionado.is_condominio}
                                                                bairro={dataRelacionado.bairro}
                                                                cidade={dataRelacionado.cidade}
                                                                ap_bloco={dataRelacionado.ap_bloco}
                                                                ap_numero={dataRelacionado.ap_numero}
                                                                marginRight='10px'
                                                            />
                                                        ))
                                                    }
                                                    {
                                                        (!item.imoveis || item.imoveis.length < 1) && (
                                                            <p style={{ color: '#777777' }}>
                                                                Nenhum imóvel cadastrado neste carrossel. Considere adicionar alguns ou delete o carrossel
                                                            </p>
                                                        )
                                                    }

                                                </Carousel>
                                            </div>
                                        </div>
                                    )
                                })
                            )}
                            {imoveisCarrosseis.length === 0 && <p style={{ color: '#777777' }}>Você ainda não possui pastas de imóveis</p>}

                        </div>
                    </WrapperCarrossel>

                    <Wrapper>
                        <div className='conten-cards-imoveis'>
                            <h3>Seus imóveis adicionados</h3>
                            <div className="imoveis">
                                {building && building.map((item, index) => {
                                    return (
                                        <CardInfo
                                            key={index}
                                            onSuccessCarrossel={getCarrosseis}
                                            id={item.id}
                                            id_display={item.id_display}
                                            descricao={item.descricao}
                                            latitude={item.latitude}
                                            longitude={item.longitude}
                                            valor_aluguel={item.valor_aluguel}
                                            valor_venda={item.valor_venda}
                                            is_venda={item.is_venda}
                                            is_aluguel={item.is_aluguel}
                                            periodo_aluguel={item.periodo_aluguel}
                                            arquivos={item.arquivos}
                                            lat={lat}
                                            long={long}
                                            onClick={() => navigate(`/perfil/${user.id_corretor}/imovel/${item.id}`)}
                                            idBuilding={item.id}
                                            is_fixado={item.is_fixado}
                                            is_destaque={item.is_destaque_corretor}
                                            is_lancamento={item.is_lancamento}
                                            is_condominio={item.is_condominio}
                                            bairro={item.bairro}
                                            cidade={item.cidade}
                                            ap_bloco={item.ap_bloco}
                                            ap_numero={item.ap_numero}
                                            marginRight='10px'
                                        />
                                    )
                                })
                                }
                                {building.length < 1 && (
                                    <div>
                                        <p style={{ color: '#777777' }}>Você ainda não adicionou imóveis ao seu perfil.

                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Wrapper>

                </>
            }

            <Modal
                centered
                width={500}
                open={modalAvatar}
                onOk={() => setModalAvatar(false)}
                onCancel={() => setModalAvatar(false)}
                footer={null}
                zIndex={99999}
            >
                <ContentModalAvatar>
                    {
                        loading &&
                        <LoadSpinnerLogin />
                    }
                    {
                        !loading &&
                        <>
                            <p className='title-logout'>Editar sua foto de perfil</p>
                            <div className='content-button'>
                                <input type="file" onChange={(e) => setAvatar(e.target.files)} />
                                <button onClick={handleEditAvatar} >Salvar</button>
                            </div>
                        </>
                    }

                </ContentModalAvatar>
            </Modal>

            <Modal
                centered
                width={'85%'}
                height={'fit-content'}
                open={openFinance}
                footer={null}
                zIndex={99999}
                onCancel={handleCloseFinance}
                style={{ marginBlock: '2rem' }}
            >
                <ContainerIframe>
                    <Title>Simule seu Financiamento</Title>
                    <StyledIframe
                        title="Simulação de Financiamento Imobiliário"
                        src="https://hubnogueira.hubfi.com.br/fin-imob"
                    />
                </ContainerIframe>
            </Modal>

            <Modal
                centered
                height={'fit-content'}
                width={'85%'}
                className='modal-carrossel'
                open={editingCarrossel}
                footer={null}
                zIndex={99999}
                onCancel={handleCLoseEditCarrossel}
                style={{ marginBlock: '2rem' }}
            >
                <div style={{ padding: '2rem' }}>
                    <Title>
                        {idEditingCarrossel === -1 ? 'Adicionar novo Carrossel' : 'Editar seu carrossel de imóveis'}
                    </Title>

                    <InputGroup>
                        <Label>Nome do carrossel:<span style={{ color: 'red' }}>*</span></Label>
                        <Input
                            type="text"
                            value={nomeEditingCarrossel}
                            onChange={(e) => setNomeEditingCarrossel(e.target.value)}
                        />
                    </InputGroup>

                    <InputGroup>
                        <Label>Descrição:</Label>
                        <TextArea
                            value={descricaoEditingCarrossel}
                            onChange={(e) => setDescricaoEditingCarrossel(e.target.value)}
                        />
                    </InputGroup>

                    <InputGroup>
                        <Label>
                            <input
                                type="checkbox"
                                checked={publicadoEditingCarrossel}
                                onChange={(e) => setPublicadoEditingCarrossel(e.target.checked)}
                                style={{ marginRight: '8px' }}
                            />
                            Publicado
                        </Label>
                    </InputGroup>

                    <Label>Imóveis no carrossel:<span style={{ color: 'red' }}>*</span></Label>

                    <CardImovelList
                        addIMoveltoCarrossel={addIMoveltoCarrossel}
                        onDelete={removeIMovelfromCarrossel}
                        imoveis={imoveisEditing}
                        idImoveisEditing={idImoveisEditing}
                        setIdImoveisEditing={setIdImoveisEditing}
                    />

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <SaveButton disabled={!nomeEditingCarrossel || !imoveisEditing || imoveisEditing.length < 1} onClick={handleEditCarrossel}>
                            Salvar
                        </SaveButton>
                    </div>
                </div>

            </Modal>

            <GoToTop />
            <Footer />
        </Container >
    );
}